import React, { useContext } from "react";
import { Grid, Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { MyButton } from "../../components/my-button/MyButton";
import { Circle } from "../../components/Circle";
import MyContext from "../../contexts/MyContext";
export const FormWrapper = (props) => {
  const { t } = useTranslation();
  const myContext = useContext(MyContext);
  const onBack = () => {
    myContext.changeActiveSlide((myContext.activeSlide -= 1));
  };
  return (
    <Grid container style={{ padding: "1rem" }}>
      <Box component="h1" color="primary.main" sx={{ marginTop: 0, marginBottom: "1rem", marginLeft: 0, fontSize: {xs: "1.4rem", sm: "1.8rem", md: "2.2rem", lg: "2.4rem", xl: "2.6rem"}}}>
        {t("apply_for_reimbursement")}
      </Box>
      <Typography hidden={myContext.activeSlide !== 0} component="small" sx={{ marginBottom: "1rem", display: "block" }} >
        {t("reimbursement_subtext")}
      </Typography>
      <Grid container item xs={12} sm={12} alignItems="center" wrap="nowrap" style={{ marginBottom: "0.5rem" }}>
        <Circle>{props.number}</Circle>
        <p style={{ marginTop: "0", marginBottom: "0", marginLeft: "1rem", wordBreak: "break-all" }}>{props.heading}</p>
      </Grid>
      <p id="required-description" className="margin bottom-0">
        <Box component="small" color="error.main">
          *
        </Box>
        <small> {t("required_field")}</small>
      </p>
      <Grid container item xs={12} sm={12} justifyContent="center">
        {props.children}
      </Grid>
      <div style={{ width: "100%" }}>
        {(props.hasContinueButton == null || props.hasContinueButton !== false) && (
          <MyButton style={{ float: "right" }} className="button primary" text={props.continueButtonLabel ?? t("continue")} onClick={props.onContinue} />
        )}
        {(props.hasBackButton == null || props.hasBackButton !== false) && (
          <MyButton
            style={{ float: "right" }}
            className="button primary margin right-1"
            text={props.backButtonLabel ?? t("back")}
            color="default"
            onClick={onBack}
            buttonVariant="outlined"
          />
        )}
      </div>
    </Grid>
  );
};
